import * as _ from 'underscore';
import { Templates } from '../../compile';
import { ConfirmModalOptions } from '../../interfaces/options';
import { DefaultModalOptions } from './modal';

export const DefaultConfirmModalOptions: ConfirmModalOptions = <ConfirmModalOptions>_.defaults(
	<ConfirmModalOptions>{
		contentTemplate: Templates.modal_confirm,
		width: '25%',
		init: false
	},
	DefaultModalOptions
);
